import {redirect} from 'react-router-dom';
import {store as AppStore} from '../store/store';
import {storeVehicleData} from './partials/store_vehicle_data';
import {handleErrors, handleSuccess} from '../support/handle_errors_success.ts';

export async function postVehicleAction(store: typeof AppStore, request: Request) {
    if (request.method !== 'POST') {
        throw new Response('', {status: 405});
    }

    const token = store.getState().exchangeToken.token;
    if (token) {
        const formData = await request.formData();
        try {
            await storeVehicleData(store, token, formData);
            handleSuccess();
        } catch (errors) {
            console.error(errors);
            handleErrors(errors);
        }
    }
    return redirect(request.url);
}
